import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store';
import { SelectSitePayload } from 'ui/components/SitePicker/site.types';

type State = SelectSitePayload;

const initialState: State = {
  site: null,
  currentSelectedSite: undefined
};

export const siteSlice = createSlice({
  name: 'site',
  initialState,
  reducers: {
    setSelectedSite: (state, action: PayloadAction<SelectSitePayload>) => {
      state.site = action.payload.site;
      state.currentSelectedSite = action.payload.currentSelectedSite;
    }
  }
});

export const selectSiteData = createSelector(
  (state: RootState) => state.site,
  (alertsState: State) => alertsState
);

export const { setSelectedSite } = siteSlice.actions;

export default siteSlice.reducer;
